import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetLevelofWorkDropdownsService = () => {
  return HTTP_CLIENT.get(Endpoint.questionnaire.getLevelOfWorkDropdowns);
};

const GetAllDropdownsWithOptionsService = (payload: any) => {
  return HTTP_CLIENT.post(
    Endpoint.questionnaire.getAllDropdownsWithOptions,
    payload
  );
};

interface GetAppOutcomesServicePayload {
  level: string;
  outcome: string;
}

const GetAppOutcomesService = (payload: GetAppOutcomesServicePayload) => {
  return HTTP_CLIENT.get(
    Endpoint.questionnaire.getAppOutComes +
      `?level=${payload?.level}&outcome=${payload?.outcome}`
  );
};

const GetQuestionsService = () => {
  return HTTP_CLIENT.get(Endpoint.questionnaire.getQuestions);
};

export {
  GetLevelofWorkDropdownsService,
  GetAllDropdownsWithOptionsService,
  GetAppOutcomesService,
  GetQuestionsService,
};
